import InfoBlock from './InfoBlock'
import WheelBlock from './WheelBlock'

export default function EmotionWheelApp() {
  return (
    <div className="flex max-w-none min-w-0 grow flex-col xl:container xl:mx-auto">
      <InfoBlock />
      <WheelBlock />
    </div>
  )
}
